import * as React from "react";
import { useEffect, useState } from "react";
import Api from "../../util/Api";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import m from "moment";
import ConfigurationPage from "../../templates/ConfigurationPage";
import {Message, useToaster} from "rsuite";
import MiniLoader from "../../components/MiniLoader";
import Pagination from 'rsuite/Pagination';

function DevicesListOld({ auth, history }) {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const toaster = useToaster();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  /**
   * Start
   */
  useEffect(() => {
    fetchDevices();
  }, []);

  const handleChangePage = pageKey => {
    console.log({pageKey});
    setPage(pageKey)

    const pageData = filteredDevices.filter((v, i) => {
      const start = limit * (pageKey - 1);
      const end = start + limit;
      return i >= start && i < end;
    });

    setFilteredDevices(pageData);
  }

  const handleChangeLimit = limitKey => {
    console.log({limitKey});
    const pageData = filteredDevices.filter((v, i) => {
      const start = limitKey * (page - 1);
      const end = start + limitKey;
      return i >= start && i < end;
    });

    setFilteredDevices(pageData);
    setLimit(limitKey);
  }

  /**
   * Room name will be a combo of Room Name and if exists the bed name.
   * @param room_name
   * @param bed_name
   * @returns {*}
   */
  function buildRoomName(room_name, bed_name) {
    return room_name + (bed_name ? " - " + bed_name : "");
  }
  /**
   * Get all devices
   */
  function fetchDevices() {
    setLoading(true);
    Api.withAuth(auth)
      .getDevices(auth.currentUser.defaultOrg)
      .then((response) => {
        const gridData = response.map((device) => {

          device.id = device.device_id;
          device.stateLevel = device.state === "staged" ? 0 : 1;
          device.isSelected = false;
          device.isHovering = false;
          return device;
        });
        const sorted = _.sortBy(gridData, ["stateLevel"], ["asc"]);
        // console.log({ sorted });
        setDevices(sorted);
        setFilteredDevices(sorted);
        setLoading(false);
        // console.log({ gridData });
      })
        .catch(() => {
          toaster.push(
              <Message type="warning">
                <h6>Warning</h6>
                <p className='m-0'>Something went wrong while loading devices data.</p>
              </Message>,
              {
                placement: "topEnd"
              });
        });
  }

  function handleRowClick(event) {
    console.log(`Click row ${{ event }}`);
  }

  function handleEditRowClick(e) {
    console.log({ e });
    const deviceId = e.target.dataset.deviceId;
    const device = devices.find((d) => d.device_id === deviceId);
    console.log({ device });
    // eslint-disable-next-line no-debugger
    // debugger;
    if (device) {
      history.push({
        pathname: `/configuration/devices-edit/`,
        state: { selectedDevices: [device] },
      });
    }
  }

  function handleUnassignRowClick(e) {
    const deviceId = e.target.dataset.deviceId;
    if (window.confirm(`Are you sure you want to unassign:\r ${deviceId}?`)) {
      try {
        return Api.withAuth(auth)
          .unassignDevices([deviceId])
          .then((response) => {
            fetchDevices();
            console.log({ response });
            return true;
          })
          .catch((error) => {
            window.alert(`${deviceId} not found.`);
            console.log(error);
          });
      } catch (error) {
        console.log({ error });
      }
    }
  }

  function handleRowMouseOver(e) {
    // console.log({e});
    // eslint-disable-next-line no-debugger
    // debugger;
    // setShowContextIcons(!showContextIcons);
  }

  function handleSearch(event) {
    const filter = devices.filter((device) =>
      device.device_id.toLowerCase().startsWith(event.target.value)
    );
    if (filter) {
      setFilteredDevices(filter);
    } else {
      setFilteredDevices(devices);
    }
  }

  function handleRowChecked(event) {
    const deviceId = event.target.dataset.deviceId;
    const checked = event.target.checked;
    const selectedDevice = devices.find(
      (device) => device.device_id === deviceId
    );
    if (checked) {
      setSelectedRows([...selectedRows, selectedDevice]);
    } else {
      const filtered = selectedRows.filter((row) => row.device_id !== deviceId);
      setSelectedRows(filtered);
    }
  }

  function handleEditMultipleDevices() {
    // console.log({ selectedRows });
    history.push({
      pathname: `/configuration/devices-edit/`,
      state: { selectedDevices: selectedRows },
    });
  }

  function handleUnassignMultipleDevices(event) {
    // console.log(`UnassignMultiple ${event}`);
    if (
      window.confirm(
        `Are you sure you want to unassign:\r ${selectedRows.map(
          (row) => row.device_id + "\r"
        )}`
      )
    ) {
      try {
        Api.withAuth(auth)
          .unassignDevices(selectedRows.map((row) => row.device_id))
          .then((response) => {
            fetchDevices();
            console.log({ response });
          })
          .catch((error) => {
            window.alert(
              "An error occurred. One of the devices may not exist. TODO: FILL IN WITH MORE ERROR INFO"
            );
            console.log(error);
          });
      } catch (error) {
        console.log({ error });
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  function clearAllChecked() {
    setSelectedRows([]);
  }

  return (
    <ConfigurationPage pageTitle="Devices" history={history}>
      <ConfigurationPage.Content>
        <div className="row">
          <div className="col-md-12 room-search-actions">
            {selectedRows.length === 0 && (
              <input
                type="text"
                className={"form-control"}
                style={{ maxWidth: "500px", marginBottom: "10px" }}
                placeholder="Search devices"
                onChange={handleSearch}
              />
            )}
            {selectedRows.length > 0 && (
              <div className="col-md">
                <span>
                  {selectedRows.length} row{selectedRows.length > 1 ? "s" : ""}{" "}
                  selected.
                </span>
                <button
                  className="btn btn-outline-info"
                  style={{
                    maxWidth: "200px",
                    height: "40px",
                    color: "#22A3BF",
                    marginLeft: "10px",
                  }}
                  onClick={handleUnassignMultipleDevices}
                >
                  Deselect All
                </button>
                <button
                  className="btn btn-outline-info float-right"
                  style={{ maxWidth: "200px", height: "40px", color: "#22A3BF" }}
                  onClick={handleUnassignMultipleDevices}
                >
                  Unassign
                </button>
                <button
                  className="btn btn-primary float-right"
                  style={{ maxWidth: "200px", height: "40px" }}
                  onClick={handleEditMultipleDevices}
                >
                  Edit
                </button>
              </div>
            )}
          </div>
        </div>
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={filteredDevices.length}
            limitOptions={[10, 30, 50]}
            limit={limit}
            activePage={page}
            onChangePage={handleChangePage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
        { loading ? <MiniLoader/> :
            <table className="table device-table table-bordered">
          <thead>
            <tr>
              <th>
                <input type="checkbox" />
              </th>
              <th>Device ID</th>
              <th>Location</th>
              <th>Resident</th>
              <th>Status</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {filteredDevices &&
              filteredDevices.map((device, key) => (
                <tr
                  key={key}
                  className="device-row"
                  onClick={handleRowClick}
                  onMouseOver={handleRowMouseOver}
                >
                  <td>
                    <input
                      type="checkbox"
                      data-device-id={device.device_id}
                      onClick={handleRowChecked}
                    />
                  </td>
                  <td>{device.device_id}</td>
                  <td>
                    <p>
                      {device.location
                        ? buildRoomName(
                            device.location.room_name,
                            device.location.bed_name
                          )
                        : "UNASSIGNED"}
                    </p>
                    <p className="device-location">
                      {device.location &&
                        `${device.location.facility} / ${device.location.section}`}
                    </p>
                  </td>
                  <td>
                    {device.resident && (
                      <>
                        <p>{`${device.resident.first_name} ${device.resident.last_name}`}</p>
                        <p className="device-location">
                          {m(device.resident.dob).format("M/D/YYYY")}
                        </p>
                      </>
                    )}
                    <p>{!device.resident && "NO RESIDENT"}</p>
                  </td>
                  <td>{device.state}</td>
                  <td align={"right"}>
                    {device.state === "deployed" ? (
                      <a
                        title={`Edit Device ${device.device_id}`}
                        className={"icon-pencil"}
                        data-device-id={device.device_id}
                        onClick={handleEditRowClick}
                      >
                        &nbsp;
                      </a>
                    ) : (
                      <a
                        title={`Assign Device ${device.device_id}`}
                        className={"icon-user-follow"}
                        data-device-id={device.device_id}
                        onClick={handleEditRowClick}
                      >
                        &nbsp;
                      </a>
                    )}
                    {device.state === "deployed" && (
                      <a
                        title={`Unassign Device ${device.device_id}`}
                        className="icon-user-unfollow"
                        data-device-id={device.device_id}
                        style={{ color: "red" }}
                        onClick={handleUnassignRowClick}
                      >
                        &nbsp;
                      </a>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        }
      </ConfigurationPage.Content>
    </ConfigurationPage >
  );
}

export default withRouter(DevicesListOld);
